import billingApiModule from '../billingApi.module';

class BillingPaymentApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getPaymentMethods() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/payment-methods`
        );
    }

    updateCurrentPaymentMethod(paymentMethodId) {
        return this.apiUtil.putWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${
                this.__env.billingApiUrl
            }/api/v1/payment-methods/${paymentMethodId}`,
            {
                default: true
            }
        );
    }

    createPayment(paymentDetail) {
        return this.apiUtil.postWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/payments`,
            paymentDetail
        );
    }
}

export default billingApiModule.service(
    'billingPaymentApiService',
    BillingPaymentApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/payment/billingPaymentApi.service.js